import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import authService from '../../services/authService';
import { useAuth } from '../../contexts/AuthProvider';

import { setMerlino } from '../../services/merlinoService';

const LoginForm = ({ setErrorMessage, errorMessage }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const { login } = useAuth();

  const navigate = useNavigate();

  const validateForm = () => {
    let isValid = true;

    if (!username) {
      setUsernameError('Email obbligatoria');
      isValid = false;
    } else {
      setUsernameError('');
    }

    if (!password) {
      setPasswordError('Password obbligatoria');
      isValid = false;
    } else {
      setPasswordError('');
    }

    return isValid;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const data = await authService.login(username, password);

      if (data.t) {
        localStorage.setItem('token', data.t);
        sessionStorage.setItem('mU', JSON.stringify(data.u));
        setMerlino(data);

        login();
        navigate('/ElencoOrdini');
      } else {
        sessionStorage.removeItem('mID');
      }
    } catch (error) {
      sessionStorage.removeItem('mID');
      if (error.response.status === 401) {
        setErrorMessage('Attenzione, credenziali non valide');
      } else if (error.response.status === 403) {
        setErrorMessage('Attenzione, password scaduta');
      } else {
        setErrorMessage('Attenzione, accesso non autorizzato');
      }
    }
  };

  return (
	<div className="content d-flex justify-content-center align-items-center">
		<form className="login-form needs-validation" noValidate onSubmit={handleLogin}>
			<div className="card mb-0">
				<div className="card-body">
				<div className="text-center mb-3">
					<h5 className="mb-0">Dashboard Ordini</h5>
					<span className="d-block text-muted">Inserisci le tue credenziali</span>
				</div>

				{/* Campo Username */}
				<div className="mb-3">
					<label className="form-label">Email</label>
					<div className="form-control-feedback form-control-feedback-start">
					<input
						type="text"
						className={`form-control form-control-lg ${usernameError ? 'is-invalid' : ''}`}
						value={username}
						onChange={(e) => setUsername(e.target.value)}
					/>
					{usernameError && <div className="invalid-tooltip bg-transparent py-0">{usernameError}</div>}
					<div className="form-control-feedback-icon">
						<i className="ph-user-circle text-muted"></i>
					</div>
					</div>
				</div>

				{/* Campo Password */}
				<div className="mb-3">
					<label className="form-label">Password</label>
					<div className="form-control-feedback form-control-feedback-start position-relative">
					<input
						type={passwordVisible ? 'text' : 'password'}
						className={`form-control form-control-lg ${passwordError ? 'is-invalid' : ''}`}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					{passwordError && <div className="invalid-tooltip bg-transparent py-0">{passwordError}</div>}
					{/* Icona del lucchetto a sinistra */}
					<div className="form-control-feedback-icon">
						<i className="ph-lock text-muted"></i>
					</div>
					{/* Icona dell'occhio a destra */}
					<button
						type="button"
						className="btn position-absolute end-0 top-50 translate-middle-y me-2"
						style={{
						background: 'none',
						border: 'none',
						padding: 0,
						cursor: 'pointer',
						}}
						onClick={() => setPasswordVisible((prev) => !prev)}
					>
						<i className={`ph-eye${passwordVisible ? '-slash' : ''} text-muted`}></i>
					</button>
					</div>
				</div>

				{/* Bottone di Login */}
				<div className="mb-3">
					<button type="submit" className="btn btn-outline-dark w-100">Accedi</button>
				</div>

				{/* Messaggio di errore */}
				{errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

				{/* 
					<div className="text-center">
						<a href="login_password_recover.html">Password dimenticata?</a>
					</div>
				
				*/}
				
				</div>
			</div>
			</form>
	</div>
  );
};

LoginForm.propTypes = {
  setErrorMessage: PropTypes.func.isRequired,
};

export default LoginForm;
